import styled from 'styled-components';
import { PaymentAgreementText as PaymentAgreementTextComponent } from './PaymentAgreementText';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
    margin-top: 5px;
  }
`;

export const Form = styled.form`
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 20px;
  border-radius: 21px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
  }
`;

export const Chips = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 15px;
  }
`;

export const PaymentAgreementText = styled(PaymentAgreementTextComponent)`
  margin-top: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 0;
  }
`;
